var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "tabs",
            fn: function () {
              return [
                _c(
                  "el-tabs",
                  {
                    staticClass: "bg-white",
                    on: {
                      "tab-click": function ($event) {
                        return _vm.toQuery()
                      },
                    },
                    model: {
                      value: _vm.listQuery.search_depend_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "search_depend_type", $$v)
                      },
                      expression: "listQuery.search_depend_type",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "全部设备", name: "-1" },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.deviceNameObj, function (item, index) {
                      return _c("el-tab-pane", {
                        attrs: { label: index, name: "" + item + "" },
                      })
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "defult",
            fn: function () {
              return [
                _vm.user_type == 2
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "商户归属:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.search_user_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "search_user_type", $$v)
                              },
                              expression: "listQuery.search_user_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "本人", value: 0 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "下级", value: 1 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.listQuery.search_depend_type == 3
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "设备类型:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.device_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "device_type", $$v)
                              },
                              expression: "listQuery.device_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "10路桩", value: "DianLaLa104G" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "16路桩",
                                value: "DianLaLa16TCP4G",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "2路4G", value: "DianLaLa4G" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "2路蓝牙", value: "DianLaLaBLE" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "2路大功率",
                                value: "DianLaLaHP4G",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "2路刷卡2200瓦",
                                value: "DianLaLaS4G",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "未使用:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.days,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "days", $$v)
                          },
                          expression: "listQuery.days",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "0天", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "3天", value: "3" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "7天", value: "7" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "排序方式:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.sort_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "sort_type", $$v)
                          },
                          expression: "listQuery.sort_type",
                        },
                      },
                      _vm._l(_vm.sort_type, function (item, key) {
                        return _c("el-option", {
                          attrs: { label: item, value: key },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                [7, 8].indexOf(_vm.listQuery.sort_type) > -1
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "选择月份:" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "month",
                            "value-format": "yyyy-M",
                            placeholder: "选择月份",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toQuery()
                            },
                          },
                          model: {
                            value: _vm.form.query_month,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "query_month", $$v)
                            },
                            expression: "form.query_month",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否铺货:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.is_distributed,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "is_distributed", $$v)
                          },
                          expression: "listQuery.is_distributed",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未铺货", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已铺货", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否冻结:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.is_frozen,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "is_frozen", $$v)
                          },
                          expression: "listQuery.is_frozen",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "-1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未冻结", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已冻结", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "商户名称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_store_name", $$v)
                        },
                        expression: "form.search_store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-down",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-down",
                    attrs: { label: "设备编号:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "goods_sn", $$v)
                        },
                        expression: "form.goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "商户ID:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.store_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "store_id", $$v)
                        },
                        expression: "form.store_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user_type != 2
                  ? [
                      _vm.user_type == 1
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "hidden-lg-and-down",
                              attrs: { label: "代理ID:" },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.son_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "son_id", $$v)
                                  },
                                  expression: "form.son_id",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "创建时间:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "开始日期",
                          "value-format": "timestamp",
                          "picker-options": _vm.beginOptions,
                        },
                        model: {
                          value: _vm.form.begin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "begin", $$v)
                          },
                          expression: "form.begin",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "结束日期",
                          "value-format": "timestamp",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.form.end,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end", $$v)
                          },
                          expression: "form.end",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.outTab("list_table", "商户记录")
                          },
                        },
                      },
                      [
                        _vm._v("导出"),
                        _c("i", { staticClass: "el-icon-male el-icon--right" }),
                      ]
                    ),
                    _vm._v(" "),
                    String(_vm.listQuery.is_frozen) === "1"
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              "font-weight": "bold",
                              color: "#f56c6c",
                              display: "inline-block",
                            },
                          },
                          [
                            _vm._v(
                              "已冻结商户可提金额合计：￥" +
                                _vm._s(_vm.frozenAvailableTotal)
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _vm.checkRoles(["terminal"])
                  ? _c("sel-plat", {
                      attrs: { "list-query": _vm.listQuery },
                      on: {
                        change: function ($event) {
                          return _vm.toQuery()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "商户名称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_store_name", $$v)
                        },
                        expression: "form.search_store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-up",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user_type == 1
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "hidden-xg-and-up",
                        attrs: { label: "代理ID:" },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.son_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "son_id", $$v)
                            },
                            expression: "form.son_id",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "list_table",
                staticClass: "ptd-5",
                attrs: {
                  id: "list_table",
                  data: _vm.list,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                  "max-height": _vm.tableMaxH,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "门店头照", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-avatar", {
                            attrs: {
                              shape: "square",
                              size: 60,
                              src: scope.row.avatar,
                              fit: "fill",
                              icon: "el-icon-picture-outline",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "dnone" }, [
                            _vm._v("【用户ID：" + _vm._s(scope.row.aid) + "】"),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商户名称", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            [" +
                              _vm._s(scope.row.id) +
                              "]" +
                              _vm._s(scope.row.store_name)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            创建日期：" +
                              _vm._s(
                                _vm.parseTime(scope.row.add_date, "{y}-{m}-{d}")
                              ) +
                              "\n            "
                          ),
                          scope.row.is_frozen == 1
                            ? _c("span", { staticClass: "frozen-badge" }, [
                                _vm._v("⚠异"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商户地址", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "text-cut_two" }, [
                            _vm._v(_vm._s(scope.row.address)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "标签", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "tag-container" },
                            [
                              scope.row.label_list &&
                              scope.row.label_list.length > 0
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "primary",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.label_list[0].label_name
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    scope.row.label_list.length > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "more-tag",
                                            attrs: {
                                              type: "info",
                                              effect: "plain",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showAllTags(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  +" +
                                                _vm._s(
                                                  scope.row.label_list.length -
                                                    1
                                                ) +
                                                " 更多\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "edit-tags-btn",
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editTags(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                编辑标签\n              "
                                      ),
                                    ]
                                  ),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "城市区域" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.region_tag &&
                                  _vm.areaObj[scope.row.region_tag]
                                  ? _vm.areaObj[scope.row.region_tag].title
                                  : "--"
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.checkRoles(["partner"]) && _vm.checkHidRole("storePclbjexs")
                  ? _c("el-table-column", {
                      attrs: { label: "总收益", width: "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-blue cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toEdit({
                                          id: scope.row.id,
                                          type: 17,
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3846429687
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkHidRole("storePclbjexs")
                  ? _c("el-table-column", {
                      attrs: { label: "交易金额", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            ￥" +
                                    _vm._s(scope.row.order_amount) +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        600078757
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkHidRole("storePclbjexs")
                  ? _c("el-table-column", {
                      attrs: { label: "可提", width: "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.checkRoles(["partner"]) &&
                                _vm.checkHidRole("store_ktxje")
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "text-blue cursor",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$refs.editwith.showDialog(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              scope.row.available_withdraw_money
                                            )
                                        ),
                                      ]
                                    )
                                  : _c("a", [
                                      _vm._v(
                                        "￥" +
                                          _vm._s(
                                            scope.row.available_withdraw_money
                                          )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2483492150
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "设备类型", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.cdbcount > 0
                            ? _c("span", [
                                _vm._v(
                                  "4G充电宝 " +
                                    _vm._s(scope.row.cdbcount) +
                                    "台"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cdxcount > 0
                            ? _c("span", [
                                _vm._v(
                                  "充电线 " + _vm._s(scope.row.cdxcount) + "条"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cdz10count > 0
                            ? _c("span", [
                                _vm._v(
                                  "10路桩 " +
                                    _vm._s(scope.row.cdz10count) +
                                    "台"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cdz16count > 0
                            ? _c("span", [
                                _vm._v(
                                  "16路桩 " +
                                    _vm._s(scope.row.cdz16count) +
                                    "台"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cdz2count > 0
                            ? _c("span", [
                                _vm._v(
                                  "2路4G " + _vm._s(scope.row.cdz2count) + "个"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cdz2lycount > 0
                            ? _c("span", [
                                _vm._v(
                                  "2路蓝牙 " +
                                    _vm._s(scope.row.cdz2lycount) +
                                    "个"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cdz2hpcount > 0
                            ? _c("span", [
                                _vm._v(
                                  "2路大功率 " +
                                    _vm._s(scope.row.cdz2hpcount) +
                                    "个"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.zmcdbcount > 0
                            ? _c("span", [
                                _vm._v(
                                  "桌面充电宝 " +
                                    _vm._s(scope.row.zmcdbcount) +
                                    "个"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.lykgczcount > 0
                            ? _c("span", [
                                _vm._v(
                                  "蓝牙开关插座 " +
                                    _vm._s(scope.row.lykgczcount) +
                                    "个"
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "上级代理", width: "115" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm.checkHidRole("storePclbsjhxs")
                            ? [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.agent_name || "--")
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.agent_phone) +
                                    "\n          "
                                ),
                              ]
                            : undefined
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "分润人", width: "130" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm.checkHidRole("storePclbsjhxs")
                            ? [
                                _vm._v(
                                  "\n            " + _vm._s(scope.row.name)
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.phone) +
                                    "\n          "
                                ),
                              ]
                            : undefined
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _vm.checkRoles(["partner"])
                  ? _c("el-table-column", {
                      attrs: { label: "投放天数" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.todays(scope.row.add_date)) +
                                    "天\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2728443467
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getToken("agent_id") == 173
                  ? _c("el-table-column", {
                      attrs: { label: "盈利状态", width: "129" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "edit-tags-btn",
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.breakEvenCalculationFun(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              编辑回本测算\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3207326563
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getToken("agent_id") == 173
                  ? _c("el-table-column", {
                      attrs: { label: "盈利金额", width: "129" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.break_even_profit
                                  ? _c("span", [
                                      _vm._v(
                                        "￥" +
                                          _vm._s(scope.row.break_even_profit)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3476892055
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getToken("agent_id") == 173
                  ? _c("el-table-column", {
                      attrs: { label: "已收金额", width: "129" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.total_change_money
                                  ? _c("span", [
                                      _vm._v(
                                        "￥" +
                                          _vm._s(scope.row.total_change_money)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3966201815
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getToken("agent_id") == 173
                  ? _c("el-table-column", {
                      attrs: { label: "回本倒计时", width: "129" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.days_since_operation
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.days_since_operation)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1873227033
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商户详情" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-link",
                            {
                              attrs: {
                                href: "/shop/detail/" + scope.row.id,
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#409EFF" } },
                                [_vm._v("查看详情")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "最后登录时间", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.login_time,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    width: "270",
                    fixed: _vm.device == "desktop" ? "right" : false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.zuo_sn
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      round: "",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.distribu(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("铺货")]
                                ),
                              ]
                            : [
                                _vm.checkHidRole("storePcdlmm")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toEdit({
                                              aid: scope.row.aid,
                                              type: 5,
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v("登录密码")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"]) &&
                                _vm.checkHidRole("storePctxmm")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toEdit({
                                              aid: scope.row.aid,
                                              type: 7,
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v("提现密码")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      round: "",
                                      plain: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            (_vm.user_type == 0
                                              ? "/order/meOrder"
                                              : "/order/subOrder") +
                                            "?store_id=" +
                                            scope.row.id,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v("订单详情")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.checkHidRole("storePcyysj")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toEdit({
                                              row: scope.row,
                                              type: 6,
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v("营业时间")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canElectricityConfig(scope.row)
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openElectricityConfig(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("电费配置")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkHidRole("storePcczjl")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getSetRecord(
                                              scope.row.aid
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("操作记录")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkRoles(["terminal"]) &&
                                _vm.checkHidRole("storePclbjexs")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "/home/income?son_id=" +
                                                scope.row.aid,
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("收益明细")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkRoles(["terminal"]) &&
                                _vm.checkHidRole("storePcbjsh")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "/shop/edit/" + scope.row.id,
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("编辑商户")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (_vm.agentInfo.steal_order_right == 1 ||
                                  scope.row.steal_order_switch == 1) &&
                                _vm.checkHidRole("storePcddgb")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getSetSteal(scope.row.id)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.steal_order_right == 1 ||
                                              scope.row.steal_order_switch == 1
                                              ? "掉单开启"
                                              : "掉单关闭"
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown",
                                  { attrs: { trigger: "click" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                      },
                                      [_vm._v("更多设置")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        staticStyle: {
                                          "max-height": "500px",
                                          "overflow-y": "auto",
                                        },
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _vm.checkHidRole("storePcmfdy")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$router.push({
                                                      path:
                                                        "/shop/setvip?store_id=" +
                                                        scope.row.id,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("免费店员")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("storePctxgx")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      aid: scope.row.aid,
                                                      type: 8,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("提现更新")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePctxsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$router.push({
                                                      path:
                                                        "/shop/withdraw?aid=" +
                                                        scope.row.aid,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("提现设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("storePcggqx")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$router.push({
                                                      path:
                                                        "/adver/setPower?son_id=" +
                                                        scope.row.aid,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("广告权限")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("storePchlly")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.editShopPart(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row
                                                      .advance_buletooth == 1
                                                      ? "先连蓝牙"
                                                      : "后连蓝牙"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.divide_type_1 == 2 &&
                                        _vm.checkRoles(["partner"])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.showEntranceFeeObj(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("入场费")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.depend_type_name.indexOf(
                                          "套套机"
                                        ) > -1
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$router.push({
                                                      path:
                                                        "/condom/shopGoods/" +
                                                        scope.row.id,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("关联商品")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        scope.row.depend_type_name.indexOf(
                                          "密码线"
                                        ) > -1 &&
                                        _vm.checkHidRole("storePcxgz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$router.push({
                                                      path:
                                                        "/shop/public/" +
                                                        scope.row.id,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("先关注")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("setbuyprice") &&
                                        scope.row.depend_type_name.indexOf(
                                          "密码线"
                                        ) > -1 &&
                                        _vm.checkHidRole("storePccgj")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$router.push({
                                                      path:
                                                        "/shop/billing/" +
                                                        scope.row.id +
                                                        "?type=2",
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("采购价")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("storePclbjexs") &&
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("store_ktxje")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.$refs.editwith.showDialog(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("修改可提")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePctxsxfsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      aid: scope.row.aid,
                                                      type: 9,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("提现手续费设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePcyjfcsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 10,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("平台补贴设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePcxcxggsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 11,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("小程序广告设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePcyjfwfsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 14,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("夜间服务费设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePcglyjsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 15,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("概率押金设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePccxfysz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 12,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("异常退款设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storeAddtgy")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 19,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("添加推广员")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storePczhsz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      aid: scope.row.aid,
                                                      type: 13,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("账号设置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"]) &&
                                        _vm.checkHidRole("storeYezz")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      aid: scope.row.aid,
                                                      type: 16,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("余额增值")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 18,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("商户归属")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkRoles(["partner"])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.showRechargeConfig(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("充值金额配置")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("storePcscsh")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.toEdit({
                                                      id: scope.row.id,
                                                      type: 4,
                                                      index: scope.$index,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v("删除商户")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.checkHidRole("storePcsbbd")
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    _vm.deviceBindDialog = true
                                                    _vm.select_aid =
                                                      scope.row.id
                                                  },
                                                },
                                              },
                                              [_vm._v("设备绑定")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.checkRoles(["terminal"])
                                          ? [
                                              scope.row.major_pid == 0 &&
                                              _vm.checkHidRole("storePctjfd")
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            {
                                                              path:
                                                                "/shop/create?fid=" +
                                                                scope.row.aid,
                                                            }
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("添加分店")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.row.major_pid == 0 &&
                                              _vm.checkRoles(["partner"])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openBranchDialog(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("我的分店")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleViewCustomerDetail(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看跟进记录")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleCreateCustomerRecord(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("创建跟进记录")]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    limit: _vm.listQuery.limit,
                    "page-count": _vm.listQuery.page_num,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "首单免费", visible: _vm.freeDialog },
          on: {
            "update:visible": function ($event) {
              _vm.freeDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任一产品：" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.shopObj.first_free_only_once,
                      callback: function ($$v) {
                        _vm.$set(_vm.shopObj, "first_free_only_once", $$v)
                      },
                      expression: "shopObj.first_free_only_once",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fs-s2 text-gray" }, [
                    _vm._v("提示：任一产品关闭时表示每一个产品都可以免费一次"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "首单免费：" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.shopObj.first_free_switch,
                      callback: function ($$v) {
                        _vm.$set(_vm.shopObj, "first_free_switch", $$v)
                      },
                      expression: "shopObj.first_free_switch",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fs-s2 text-gray" }, [
                    _vm._v(
                      "提示：开启免费，首页地图、附近商户和用户支付页面都会出现首单免费字样"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.freeDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.postFree()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "操作记录", visible: _vm.setRecordDialog },
          on: {
            "update:visible": function ($event) {
              _vm.setRecordDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.loadSetRecord,
                  expression: "loadSetRecord",
                },
              ],
              staticClass: "pl-10",
              staticStyle: { overflow: "auto", "max-height": "350px" },
            },
            [
              _c(
                "el-timeline",
                _vm._l(_vm.setRecordList, function (item, index) {
                  return _c(
                    "el-timeline-item",
                    {
                      key: index,
                      attrs: {
                        placement: "top",
                        "hide-timestamp": "",
                        timestamp: index,
                      },
                    },
                    [
                      _c("div", { staticClass: "mb-10 fs-c1" }, [
                        _vm._v(_vm._s(index)),
                      ]),
                      _vm._v(" "),
                      _vm._l(item.list, function (sitem) {
                        return _c(
                          "div",
                          { staticClass: "mb-5 fs-s4 text-gray" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.parseTime(
                                  sitem.add_date,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              ) + " "
                            ),
                            _c("span", {
                              staticClass: "mr-10 ml-10 el-icon-right",
                            }),
                            _vm._v(" " + _vm._s(sitem.content)),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "入场费设置",
            visible: _vm.entranceFeeDialog,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.entranceFeeDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "auto" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.entranceFeeObj.divide_model,
                        callback: function ($$v) {
                          _vm.$set(_vm.entranceFeeObj, "divide_model", $$v)
                        },
                        expression: "entranceFeeObj.divide_model",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("固定返款"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("比例返款"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.entranceFeeObj.divide_model == 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "入场金额：" } },
                      [
                        _c(
                          "el-input",
                          {
                            model: {
                              value: _vm.entranceFeeObj.store_door_fee_1,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.entranceFeeObj,
                                  "store_door_fee_1",
                                  $$v
                                )
                              },
                              expression: "entranceFeeObj.store_door_fee_1",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("元")])],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "返款日期：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.entranceFeeObj.door_fee_date,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.entranceFeeObj,
                                  "door_fee_date",
                                  $$v
                                )
                              },
                              expression: "entranceFeeObj.door_fee_date",
                            },
                          },
                          _vm._l(28, function (item) {
                            return _c("el-option", {
                              attrs: {
                                label: "每月" + item + "号",
                                value: item,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.entranceFeeObj.divide_model == 2
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "总入场金额：" } },
                      [
                        _c(
                          "el-input",
                          {
                            model: {
                              value: _vm.entranceFeeObj.promise_send_money,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.entranceFeeObj,
                                  "promise_send_money",
                                  $$v
                                )
                              },
                              expression: "entranceFeeObj.promise_send_money",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("元")])],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "fs-s3 text-gray" }, [
                          _vm._v("返还入场费不会超过此金额"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "返还比例：" } },
                      [
                        _c(
                          "el-input",
                          {
                            model: {
                              value: _vm.entranceFeeObj.door_relative_percent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.entranceFeeObj,
                                  "door_relative_percent",
                                  $$v
                                )
                              },
                              expression:
                                "entranceFeeObj.door_relative_percent",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "fs-s3 text-gray" }, [
                          _vm._v("返款金额=商户上级代理的收入*返还比例"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "返款日期：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.upMoneyObj.crond_once_unit_day,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.upMoneyObj,
                                  "crond_once_unit_day",
                                  $$v
                                )
                              },
                              expression: "upMoneyObj.crond_once_unit_day",
                            },
                          },
                          _vm._l(28, function (item) {
                            return _c("el-option", {
                              attrs: {
                                label: "每月" + item + "号",
                                value: item,
                              },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "fs-s2 text-gray" }, [
                          _vm._v(
                            "提示：比例返款模式会将提现更新模式改为定时更新"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.entranceFeeDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.postEntranceFee()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "提现手续费设置", visible: _vm.withdrawFeeDialog },
          on: {
            "update:visible": function ($event) {
              _vm.withdrawFeeDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收取方式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.withdrawFeeObj.config_mode,
                        callback: function ($$v) {
                          _vm.$set(_vm.withdrawFeeObj, "config_mode", $$v)
                        },
                        expression: "withdrawFeeObj.config_mode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("跟随原配置"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("单独比例"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("单独金额"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.withdrawFeeObj.config_mode == 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "提现手续费比例：" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "flex1",
                            attrs: {
                              oninput: "value=value.replace(/[^\\d.]/g,'')",
                            },
                            model: {
                              value: _vm.withdrawFeeObj.withdraw_rate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.withdrawFeeObj,
                                  "withdraw_rate",
                                  $$v
                                )
                              },
                              expression: "withdrawFeeObj.withdraw_rate",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.withdrawFeeObj.config_mode == 2
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "提现手续费金额：" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "flex1",
                            attrs: {
                              oninput: "value=value.replace(/[^\\d.]/g,'')",
                            },
                            model: {
                              value: _vm.withdrawFeeObj.withdraw_amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.withdrawFeeObj,
                                  "withdraw_amount",
                                  $$v
                                )
                              },
                              expression: "withdrawFeeObj.withdraw_amount",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("元")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.withdrawFeeDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setWithdrawFee()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "异常退款设置",
            visible: _vm.cancelCommissionSetDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cancelCommissionSetDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开启异常退款分成：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.cancelCommissionSetObj.cancel_commission,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cancelCommissionSetObj,
                            "cancel_commission",
                            $$v
                          )
                        },
                        expression: "cancelCommissionSetObj.cancel_commission",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "取消N天前的订单：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        model: {
                          value:
                            _vm.cancelCommissionSetObj
                              .cancel_order_commission_day,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cancelCommissionSetObj,
                              "cancel_order_commission_day",
                              $$v
                            )
                          },
                          expression:
                            "cancelCommissionSetObj.cancel_order_commission_day",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("天")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "每天的取消比例：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput:
                            "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                        },
                        model: {
                          value:
                            _vm.cancelCommissionSetObj.cancel_commision_rate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cancelCommissionSetObj,
                              "cancel_commision_rate",
                              $$v
                            )
                          },
                          expression:
                            "cancelCommissionSetObj.cancel_commision_rate",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cancelCommissionSetDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setCancelCommission()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加推广员", visible: _vm.addPromoterSetDialog },
          on: {
            "update:visible": function ($event) {
              _vm.addPromoterSetDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "推广员姓名：" } },
                  [
                    _c("el-input", {
                      staticClass: "flex1",
                      model: {
                        value: _vm.addPromoterSetObj.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.addPromoterSetObj, "name", $$v)
                        },
                        expression: "addPromoterSetObj.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号码：" } },
                  [
                    _c("el-input", {
                      staticClass: "flex1",
                      model: {
                        value: _vm.addPromoterSetObj.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.addPromoterSetObj, "phone", $$v)
                        },
                        expression: "addPromoterSetObj.phone",
                      },
                    }),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "分润比例：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput:
                            "value=value > 100 ? 100 : value.replace(/[^0-9]/g, '')",
                        },
                        model: {
                          value: _vm.addPromoterSetObj.store_percent,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.addPromoterSetObj,
                              "store_percent",
                              $$v
                            )
                          },
                          expression: "addPromoterSetObj.store_percent",
                        },
                      },
                      [
                        _c("template", { slot: "append" }, [
                          _vm._v(
                            "最大不能超过" +
                              _vm._s(_vm.addPromoterSetObj.max_percent) +
                              "%"
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addPromoterSetObj.is_delete,
                        callback: function ($$v) {
                          _vm.$set(_vm.addPromoterSetObj, "is_delete", $$v)
                        },
                        expression: "addPromoterSetObj.is_delete",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addPromoterSetDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addPromoter()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "平台补贴设置", visible: _vm.banlanceSetDialog },
          on: {
            "update:visible": function ($event) {
              _vm.banlanceSetDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否开启平台补贴：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.balanceSetObj.is_deposit_sharing,
                        callback: function ($$v) {
                          _vm.$set(_vm.balanceSetObj, "is_deposit_sharing", $$v)
                        },
                        expression: "balanceSetObj.is_deposit_sharing",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "代理平台补贴比例：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput:
                            "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                        },
                        model: {
                          value: _vm.balanceSetObj.agent_sharing_ratio,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.balanceSetObj,
                              "agent_sharing_ratio",
                              $$v
                            )
                          },
                          expression: "balanceSetObj.agent_sharing_ratio",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商户平台补贴比例：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput:
                            "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                        },
                        model: {
                          value: _vm.balanceSetObj.deposit_sharing_ratio,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.balanceSetObj,
                              "deposit_sharing_ratio",
                              $$v
                            )
                          },
                          expression: "balanceSetObj.deposit_sharing_ratio",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.banlanceSetDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setBalance()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "概率押金设置", visible: _vm.isStoreYjDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isStoreYjDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "跟随系统设置：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isStoreYjObj.is_sys_credit_percent_bao,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.isStoreYjObj,
                            "is_sys_credit_percent_bao",
                            $$v
                          )
                        },
                        expression: "isStoreYjObj.is_sys_credit_percent_bao",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "概率押金(微信)：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput:
                            "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                        },
                        model: {
                          value: _vm.isStoreYjObj.low_wxcredit_percent_bao,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.isStoreYjObj,
                              "low_wxcredit_percent_bao",
                              $$v
                            )
                          },
                          expression: "isStoreYjObj.low_wxcredit_percent_bao",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "微信状态开启：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isStoreYjObj.low_wxcredit_switch,
                        callback: function ($$v) {
                          _vm.$set(_vm.isStoreYjObj, "low_wxcredit_switch", $$v)
                        },
                        expression: "isStoreYjObj.low_wxcredit_switch",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "概率押金(支付宝)：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput:
                            "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                        },
                        model: {
                          value: _vm.isStoreYjObj.low_zfbcredit_percent_bao,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.isStoreYjObj,
                              "low_zfbcredit_percent_bao",
                              $$v
                            )
                          },
                          expression: "isStoreYjObj.low_zfbcredit_percent_bao",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付宝状态开启：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isStoreYjObj.low_zfbcredit_switch,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.isStoreYjObj,
                            "low_zfbcredit_switch",
                            $$v
                          )
                        },
                        expression: "isStoreYjObj.low_zfbcredit_switch",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isStoreYjDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setStoreYj()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "小程序广告设置", visible: _vm.offAdSetDialog },
          on: {
            "update:visible": function ($event) {
              _vm.offAdSetDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小程序广告设置：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.offAdSetObj.off_ad,
                        callback: function ($$v) {
                          _vm.$set(_vm.offAdSetObj, "off_ad", $$v)
                        },
                        expression: "offAdSetObj.off_ad",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("开启")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.offAdSetDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setOffAd()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "服务费设置", visible: _vm.isNightSetDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isNightSetDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "夜间服务费设置：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isNightSetObj.is_night,
                        callback: function ($$v) {
                          _vm.$set(_vm.isNightSetObj, "is_night", $$v)
                        },
                        expression: "isNightSetObj.is_night",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isNightSetDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setIsNight()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "账号设置", visible: _vm.isFrozenDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isFrozenDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "250px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "账号设置：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_frozen,
                        callback: function ($$v) {
                          _vm.$set(_vm.isFrozenSetObj, "is_frozen", $$v)
                        },
                        expression: "isFrozenSetObj.is_frozen",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("解冻账号"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("冻结账号"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否掉单白名单：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_steal_order_white,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.isFrozenSetObj,
                            "is_steal_order_white",
                            $$v
                          )
                        },
                        expression: "isFrozenSetObj.is_steal_order_white",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否使用旧版电量或功率套餐：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_use_old_combo,
                        callback: function ($$v) {
                          _vm.$set(_vm.isFrozenSetObj, "is_use_old_combo", $$v)
                        },
                        expression: "isFrozenSetObj.is_use_old_combo",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否展示充电桩套餐：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_show_cdz_combo,
                        callback: function ($$v) {
                          _vm.$set(_vm.isFrozenSetObj, "is_show_cdz_combo", $$v)
                        },
                        expression: "isFrozenSetObj.is_show_cdz_combo",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "充电桩小时套餐是否使用固定收费：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_use_hour_position,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.isFrozenSetObj,
                            "is_use_hour_position",
                            $$v
                          )
                        },
                        expression: "isFrozenSetObj.is_use_hour_position",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否使用廉价套餐：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_use_cheap,
                        callback: function ($$v) {
                          _vm.$set(_vm.isFrozenSetObj, "is_use_cheap", $$v)
                        },
                        expression: "isFrozenSetObj.is_use_cheap",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否允许银行卡提现：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isFrozenSetObj.is_allow_withdrawal,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.isFrozenSetObj,
                            "is_allow_withdrawal",
                            $$v
                          )
                        },
                        expression: "isFrozenSetObj.is_allow_withdrawal",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "清除提现绑定的微信：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.show_confirm()
                        },
                      },
                      model: {
                        value: _vm.is_clear_wx_user,
                        callback: function ($$v) {
                          _vm.is_clear_wx_user = $$v
                        },
                        expression: "is_clear_wx_user",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "上次设置掉单白名单更新时间：" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isFrozenSetObj.operate_time) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isFrozenDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setFrozen()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "余额增值设置", visible: _vm.isYezzDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isYezzDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "余额增值设置：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isYezzSetObj.is_yezz,
                        callback: function ($$v) {
                          _vm.$set(_vm.isYezzSetObj, "is_yezz", $$v)
                        },
                        expression: "isYezzSetObj.is_yezz",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("开启")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isYezzDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setYezz()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "商户归属设置", visible: _vm.isShgsDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isShgsDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "重新设置归属：" } },
                [
                  [
                    _c("div", [
                      _c("h3", [_vm._v("城市合伙人")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search1,
                            expression: "search1",
                          },
                        ],
                        staticStyle: { width: "150px" },
                        attrs: { type: "text", placeholder: "搜索..." },
                        domProps: { value: _vm.search1 },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search1 = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isShgsSetObj.cshhr,
                              expression: "isShgsSetObj.cshhr",
                            },
                          ],
                          staticStyle: { width: "300px" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.isShgsSetObj,
                                "cshhr",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("请选择"),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.filteredOptions1,
                            function (options_cshhr) {
                              return _c(
                                "option",
                                {
                                  key: options_cshhr.value,
                                  domProps: { value: options_cshhr.value },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(options_cshhr.label) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _vm.isShgsSetObj.cshhr_cdb_percent >= 0
                            ? _c("span", [_vm._v("充电宝：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.cshhr_cdb_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.cshhr_cdb_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "cshhr_cdb_percent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "isShgsSetObj.cshhr_cdb_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.cshhr_cdx_percent >= 0
                            ? _c("span", [_vm._v("密码线：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.cshhr_cdx_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.cshhr_cdx_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "cshhr_cdx_percent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "isShgsSetObj.cshhr_cdx_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.cshhr_cdz_percent >= 0
                            ? _c("span", [_vm._v("充电桩：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.cshhr_cdz_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.cshhr_cdz_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "cshhr_cdz_percent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "isShgsSetObj.cshhr_cdz_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  _vm._v(" "),
                  [
                    _c("div", [
                      _c("h3", [_vm._v("代理商")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search2,
                            expression: "search2",
                          },
                        ],
                        staticStyle: { width: "150px" },
                        attrs: { type: "text", placeholder: "搜索..." },
                        domProps: { value: _vm.search2 },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search2 = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isShgsSetObj.dls,
                              expression: "isShgsSetObj.dls",
                            },
                          ],
                          staticStyle: { width: "300px" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.isShgsSetObj,
                                "dls",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("请选择"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.filteredOptions2, function (options_dls) {
                            return _c(
                              "option",
                              {
                                key: options_dls.value,
                                domProps: { value: options_dls.value },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(options_dls.label) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _vm.isShgsSetObj.dls_cdb_percent >= 0
                            ? _c("span", [_vm._v("充电宝：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.dls_cdb_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.dls_cdb_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "dls_cdb_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.dls_cdb_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.dls_cdx_percent >= 0
                            ? _c("span", [_vm._v("密码线：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.dls_cdx_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.dls_cdx_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "dls_cdx_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.dls_cdx_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.dls_cdz_percent >= 0
                            ? _c("span", [_vm._v("充电桩：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.dls_cdz_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.dls_cdz_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "dls_cdz_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.dls_cdz_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  _vm._v(" "),
                  [
                    _c("div", [
                      _c("h3", [_vm._v("业务员")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search3,
                            expression: "search3",
                          },
                        ],
                        staticStyle: { width: "150px" },
                        attrs: { type: "text", placeholder: "搜索..." },
                        domProps: { value: _vm.search3 },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search3 = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isShgsSetObj.ywy,
                              expression: "isShgsSetObj.ywy",
                            },
                          ],
                          staticStyle: { width: "300px" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.isShgsSetObj,
                                "ywy",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("请选择"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.filteredOptions3, function (options_ywy) {
                            return _c(
                              "option",
                              {
                                key: options_ywy.value,
                                domProps: { value: options_ywy.value },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(options_ywy.label) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _vm.isShgsSetObj.ywy_cdb_percent >= 0
                            ? _c("span", [_vm._v("充电宝：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.ywy_cdb_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.ywy_cdb_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "ywy_cdb_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.ywy_cdb_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.ywy_cdx_percent >= 0
                            ? _c("span", [_vm._v("密码线：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.ywy_cdx_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.ywy_cdx_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "ywy_cdx_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.ywy_cdx_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.ywy_cdz_percent >= 0
                            ? _c("span", [_vm._v("充电桩：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.ywy_cdz_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.ywy_cdz_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "ywy_cdz_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.ywy_cdz_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  _vm._v(" "),
                  [
                    _c("div", [
                      _c("h3", [_vm._v("商家")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _vm.isShgsSetObj.sj_cdb_percent >= 0
                            ? _c("span", [_vm._v("充电宝：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.sj_cdb_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.sj_cdb_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "sj_cdb_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.sj_cdb_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.sj_cdx_percent >= 0
                            ? _c("span", [_vm._v("密码线：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.sj_cdx_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.sj_cdx_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "sj_cdx_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.sj_cdx_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.sj_cdz_percent >= 0
                            ? _c("span", [_vm._v("充电桩：")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShgsSetObj.sj_cdz_percent >= 0
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    oninput:
                                      "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                                  },
                                  model: {
                                    value: _vm.isShgsSetObj.sj_cdz_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.isShgsSetObj,
                                        "sj_cdz_percent",
                                        $$v
                                      )
                                    },
                                    expression: "isShgsSetObj.sj_cdz_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "原来商户归属：" } },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.isShgsSetObj.belong } },
                    [
                      _c("el-table-column", {
                        attrs: { label: "角色" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.role_name) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "姓名" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.name || "--") +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "手机号码" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.phone || "--") +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShgsDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setShgs()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "收益情况", visible: _vm.isSyqkDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isSyqkDialog = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "mb-10" }, [
              _vm._v("商户收益：￥" + _vm._s(_vm.isSyqkObj.shop_profit) + "元"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-10" }, [
              _c("span", { staticClass: "gd-width" }, [
                _vm._v(
                  "可提金额：￥" + _vm._s(_vm.isSyqkObj.profit_money) + "元"
                ),
              ]),
              _vm._v(
                "---已提金额：￥" + _vm._s(_vm.isSyqkObj.withdrawn_money) + "元"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-10" }, [
              _c("span", { staticClass: "gd-width" }, [
                _vm._v(
                  "交易金额：￥" + _vm._s(_vm.isSyqkObj.order_amount) + "元"
                ),
              ]),
              _vm._v("---交易单数：" + _vm._s(_vm.isSyqkObj.order_num) + "单"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-10" }, [
              _c("span", { staticClass: "gd-width" }, [
                _vm._v(
                  "充值金额：￥" + _vm._s(_vm.isSyqkObj.total_pay_money) + "元"
                ),
              ]),
              _vm._v(
                "---赠送金额：￥" +
                  _vm._s(_vm.isSyqkObj.total_send_money) +
                  "元"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-10" }, [
              _c("span", { staticClass: "gd-width" }, [
                _vm._v(
                  "平台增值：￥" + _vm._s(_vm.isSyqkObj.pt_steal_fc) + "元"
                ),
              ]),
              _vm._v(
                "---平台补贴：￥" +
                  _vm._s(_vm.isSyqkObj.wait_deposit_sharing_income) +
                  "元"
              ),
            ]),
          ],
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isSyqkDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "可提现金额更新", visible: _vm.upMoneyDialog },
          on: {
            "update:visible": function ($event) {
              _vm.upMoneyDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "更新方式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.upMoneyObj.crond_money_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.upMoneyObj, "crond_money_type", $$v)
                        },
                        expression: "upMoneyObj.crond_money_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("实时更新"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("定时更新"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "更新日期：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.upMoneyObj.crond_once_unit_day,
                        callback: function ($$v) {
                          _vm.$set(_vm.upMoneyObj, "crond_once_unit_day", $$v)
                        },
                        expression: "upMoneyObj.crond_once_unit_day",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "每天", value: 0 } }),
                      _vm._v(" "),
                      _vm._l(28, function (item) {
                        return _c("el-option", {
                          attrs: { label: "每月" + item + "号", value: item },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.upMoneyObj.crond_money_type == 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "更新时间：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.upMoneyObj.crond_once_unit_hour,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.upMoneyObj,
                                  "crond_once_unit_hour",
                                  $$v
                                )
                              },
                              expression: "upMoneyObj.crond_once_unit_hour",
                            },
                          },
                          _vm._l(24, function (item) {
                            return _c("el-option", {
                              attrs: {
                                label: item - 1 + "点",
                                value: item - 1,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "最小更新金额：" } },
                      [
                        _c(
                          "el-input",
                          {
                            model: {
                              value: _vm.upMoneyObj.crond_min_money,
                              callback: function ($$v) {
                                _vm.$set(_vm.upMoneyObj, "crond_min_money", $$v)
                              },
                              expression: "upMoneyObj.crond_min_money",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("元")])],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "fs-s2 text-gray" }, [
                          _vm._v(
                            "注：未更新金额小于最小更新金额时，则不更新。"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.upMoneyDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.postUpMoney()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设备绑定",
            visible: _vm.deviceBindDialog,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deviceBindDialog = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 6,
              placeholder: "设备编号与编号之间用英文逗号隔开",
            },
            model: {
              value: _vm.deviceBindStr,
              callback: function ($$v) {
                _vm.deviceBindStr = $$v
              },
              expression: "deviceBindStr",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "pt-5" }, [
            _vm._v("注：设备编号与编号之间用 , 隔开(英文逗号)。"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deviceBindDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.distribu()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设备绑定结果",
            visible: _vm.deviceBindEndDialog,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deviceBindEndDialog = $event
            },
          },
        },
        [
          _vm._l(_vm.bind_success, function (item) {
            return _c("div", { staticClass: "mb-10 flex" }, [
              _c("div", [_vm._v(_vm._s(item.sn))]),
              _vm._v(" "),
              _c("div", { staticClass: "flex1 pl-20" }, [
                _vm._v(_vm._s(item.msg)),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.bind_err, function (item) {
            return _c("div", { staticClass: "mb-10 flex text-danger" }, [
              _c("div", [_vm._v(_vm._s(item.sn))]),
              _vm._v(" "),
              _c("div", { staticClass: "flex1 pl-20" }, [
                _vm._v(_vm._s(item.msg)),
              ]),
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.deviceBindEndDialog = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "掉单设置", visible: _vm.isStealDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isStealDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "p-10" }, [
            _c(
              "div",
              { staticClass: "p-20 bg-white" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { "label-width": "100px" } },
                  [
                    _c("h4", { staticClass: "mb-10 mt-0" }, [
                      _vm._v("掉单状态"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否开启：" } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.stealForm.new_steal_switch,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.stealForm,
                                    "new_steal_switch",
                                    $$v
                                  )
                                },
                                expression: "stealForm.new_steal_switch",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-5 fs-s3" }, [
                              _vm._v(
                                "开启表示开启掉单，以下规则才会生效，掉单优先顺序：比例漏单>时间扣减>扣款失败"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-10 mt-0" }, [
                      _vm._v("比例漏单及扣款失败"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订单基数：" } },
                          [
                            _c(
                              "el-input",
                              {
                                model: {
                                  value: _vm.stealForm.missed_cycle_orders,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.stealForm,
                                      "missed_cycle_orders",
                                      $$v
                                    )
                                  },
                                  expression: "stealForm.missed_cycle_orders",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("单"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-10 mt-0" }, [
                      _vm._v("比例漏单"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "漏单概率：" } },
                          [
                            _c(
                              "el-input",
                              {
                                model: {
                                  value: _vm.stealForm.missed_rate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.stealForm, "missed_rate", $$v)
                                  },
                                  expression: "stealForm.missed_rate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "起漏金额：" } },
                          [
                            _c(
                              "el-input",
                              {
                                model: {
                                  value: _vm.stealForm.missed_min_money,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.stealForm,
                                      "missed_min_money",
                                      $$v
                                    )
                                  },
                                  expression: "stealForm.missed_min_money",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-start",
                              title: "温馨提示",
                              width: "450",
                              trigger: "hover",
                            },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "\n                有效订单：订单金额大于0且未被掉单的订单。"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                起漏金额：有效订单的订单金额须大于等于起漏金额才会漏单。"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                漏掉的订单将会隐藏且不给下级代理及商户分成。"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                例：订单基数10单，概率40%，商户有效订单每10单漏4单。\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "mt-10 ml-20 el-icon-question text-blue",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.checkRoles(["partner"])
                      ? [
                          _c("h4", { staticClass: "mb-10 mt-0" }, [
                            _vm._v("时间扣减"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "扣减基数：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value: _vm.stealForm.short_cycle_orders,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "short_cycle_orders",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "stealForm.short_cycle_orders",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("单"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "扣减概率：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value: _vm.stealForm.short_rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "short_rate",
                                            $$v
                                          )
                                        },
                                        expression: "stealForm.short_rate",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "扣减时间：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value: _vm.stealForm.short_minute,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "short_minute",
                                            $$v
                                          )
                                        },
                                        expression: "stealForm.short_minute",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("分钟"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    title: "温馨提示",
                                    width: "480",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "\n                  有效订单：订单金额大于0且未被掉单的订单。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  订单真实使用时长减去扣减时间，订单金额未发生变化，则该订单不扣减时间。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  订单扣减时间后，下级看到的订单完结时间=真实完结时间-扣减时间。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  例：扣减时间10分钟，真实使用时长65分钟，订单计费为2元60分钟，该订单真实扣款4元。扣减10分钟后使用时长55分钟，订单金额2元，下级代理及商户按2元分成，剩余2元则按比例分给您及您的上级。\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "mt-10 ml-20 el-icon-question text-blue",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "mb-10 mt-0" }, [
                            _vm._v("扣款失败"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "失败概率：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value: _vm.stealForm.show_fail_rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "show_fail_rate",
                                            $$v
                                          )
                                        },
                                        expression: "stealForm.show_fail_rate",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "起漏金额：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value:
                                          _vm.stealForm.show_fail_min_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "show_fail_min_money",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "stealForm.show_fail_min_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    title: "温馨提示",
                                    width: "450",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "\n                  有效订单：订单金额大于0且未被掉单的订单。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  起漏金额：有效订单的订单金额须大于等于起漏金额才会失败。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  失败订单会展示为扣款失败，不给下级代理及商户分成。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  例：订单基数10单，概率40%，商户有效订单每10单失败4单。\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "mt-10 ml-20 el-icon-question text-blue",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "mb-10 mt-0" }, [
                            _vm._v("已完成订单漏单"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "漏单基数：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value:
                                          _vm.stealForm
                                            .missed_nologin_cycle_orders,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "missed_nologin_cycle_orders",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "stealForm.missed_nologin_cycle_orders",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("单"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "漏单概率：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value:
                                          _vm.stealForm.missed_nologin_rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "missed_nologin_rate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "stealForm.missed_nologin_rate",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "起漏金额：" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value:
                                          _vm.stealForm
                                            .missed_nologin_min_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "missed_nologin_min_money",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "stealForm.missed_nologin_min_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "ml-10",
                                  attrs: { label: "未登录时长：" },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      model: {
                                        value:
                                          _vm.stealForm.missed_nologin_hours,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stealForm,
                                            "missed_nologin_hours",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "stealForm.missed_nologin_hours",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("小时"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    title: "温馨提示",
                                    width: "450",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "\n                  有效订单：订单金额大于0且未被掉单的订单。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  起漏金额：有效订单的订单金额须大于等于起漏金额才会漏单。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  漏掉的订单将会隐藏且扣除下级代理及商户分成。"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  例：基数10单，概率40%，未登录时间6小时，若6小时内商户未登录，该时段内商户有效订单每10单漏4单，每6小时轮回。\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "mt-10 ml-20 el-icon-question text-blue",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkRoles(["partner"])
                      ? [
                          _c("h4", { staticClass: "mb-10 mt-0" }, [
                            _vm._v("隐藏订单"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "是否开启：" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.stealForm.steal_switch,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.stealForm, "steal_switch", $$v)
                                  },
                                  expression: "stealForm.steal_switch",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-5 fs-s3" }, [
                                _vm._v("开启表示以下设置时间段内的订单不显示"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁止结束：" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.stealForm.user_forbidden_finish,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.stealForm,
                                      "user_forbidden_finish",
                                      $$v
                                    )
                                  },
                                  expression: "stealForm.user_forbidden_finish",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-5 fs-s3" }, [
                                _vm._v(
                                  "开启表示以下设置时间段内的充电宝订单归还不会自动结束"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.stealForm.plan, function (item, index) {
                            return _c(
                              "div",
                              { staticClass: "flex align-start flex-wrap" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "mr-20",
                                    attrs: { label: "开始时间：" },
                                  },
                                  [
                                    _c("el-time-select", {
                                      attrs: {
                                        "picker-options": {
                                          start: "00:00",
                                          step: "00:01",
                                          end: "23:59",
                                        },
                                        placeholder: "开始时间",
                                      },
                                      model: {
                                        value: item.begin,
                                        callback: function ($$v) {
                                          _vm.$set(item, "begin", $$v)
                                        },
                                        expression: "item.begin",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "mr-20",
                                    attrs: { label: "结束时间：" },
                                  },
                                  [
                                    _c("el-time-select", {
                                      attrs: {
                                        "picker-options": {
                                          start: "00:00",
                                          step: "00:01",
                                          end: "23:59",
                                          minTime: item.begin,
                                        },
                                        placeholder: "结束时间",
                                      },
                                      model: {
                                        value: item.end,
                                        callback: function ($$v) {
                                          _vm.$set(item, "end", $$v)
                                        },
                                        expression: "item.end",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.stealForm.plan.length <
                                  _vm.config.steal_time_length && index == 0
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-plus",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.stealForm.plan.push({
                                            start: "",
                                            end: "",
                                          })
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.stealForm.plan.length > 1 && index > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "danger",
                                        icon: "el-icon-minus",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.stealForm.plan.splice(
                                            index,
                                            1
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h4",
                      {
                        staticClass: "mb-10 mt-0",
                        staticStyle: { "font-size": "14px" },
                      },
                      [_vm._v("电量度数增值比例")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex align-center" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "增值比例：" } },
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "150px" },
                                model: {
                                  value: _vm.stealForm.degree_rate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.stealForm, "degree_rate", $$v)
                                  },
                                  expression: "stealForm.degree_rate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-start",
                              title: "温馨提示",
                              width: "450",
                              trigger: "hover",
                            },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "电量度数增值比例：设置后充电订单会按此比例增加电量度数，用于补贴电费成本。"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "ml-20 el-icon-question text-blue",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.postCard()
                              },
                            },
                          },
                          [_vm._v("立即提交")]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("editwith", { ref: "editwith", attrs: { type: 2 } }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "标签管理",
            visible: _vm.tagDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tagDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tag-list" },
            [
              _vm._l(_vm.currentStoreTags, function (tag) {
                return _c(
                  "el-tag",
                  {
                    key: tag.id,
                    staticClass: "tag-item",
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.removeTag(tag)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(tag.label_name) + "\n      ")]
                )
              }),
              _vm._v(" "),
              _vm.newTagInputVisible
                ? _c("el-input", {
                    staticClass: "new-tag-input",
                    attrs: { size: "small" },
                    on: { blur: _vm.addNewTag },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.addNewTag($event)
                      },
                    },
                    model: {
                      value: _vm.newTagInput,
                      callback: function ($$v) {
                        _vm.newTagInput = $$v
                      },
                      expression: "newTagInput",
                    },
                  })
                : _c(
                    "el-button",
                    {
                      staticClass: "new-tag-button",
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.newTagInputVisible = true
                        },
                      },
                    },
                    [_vm._v("\n        + 添加标签\n      ")]
                  ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveTags } },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "我的分店",
            visible: _vm.branchDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.branchDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-money",
                    size: "small",
                    loading: _vm.mergeLoading,
                  },
                  on: { click: _vm.handleMergeFunds },
                },
                [_vm._v("一键合并可提金额")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.branchListLoading,
                  expression: "branchListLoading",
                },
              ],
              attrs: { data: _vm.branchList, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "store_name",
                  label: "商户名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "order_amount",
                  label: "交易金额",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ￥" +
                            _vm._s(scope.row.order_amount || 0) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "available_withdraw_money",
                  label: "可提金额",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ￥" +
                            _vm._s(scope.row.available_withdraw_money || 0) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "add_date", label: "创建日期", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.parseTime(
                                scope.row.add_date,
                                "{y}-{m}-{d} {h}:{i}"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.calculateCostLoading,
              expression: "calculateCostLoading",
            },
          ],
          attrs: {
            title: "",
            visible: _vm.breakEvenDialog,
            width: "90%",
            center: "",
            "title-class": "dialog-title-bold",
          },
          on: {
            "update:visible": function ($event) {
              _vm.breakEvenDialog = $event
            },
          },
        },
        [
          _c("h2", { staticStyle: { "text-align": "center" } }, [
            _vm._v("设备盈利状态测算"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "calculator-container" }, [
            _c(
              "div",
              {
                staticClass: "info-card card-shadow card-elevation",
                staticStyle: {
                  "background-color": "#FAFAFC",
                  padding: "8px",
                  "border-radius": "12px",
                },
              },
              [
                _c("h3", [_vm._v("商户信息")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex align-items-center" },
                  [
                    _c("span", [
                      _vm._v("  "),
                      _c("strong", [_vm._v("商户ID ：")]),
                      _vm._v(_vm._s(_vm.currentShopInfo.id)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-20" }, [
                      _vm._v("  "),
                      _c("strong", [_vm._v("商户名称：")]),
                      _vm._v(_vm._s(_vm.currentShopInfo.store_name)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-20" }, [
                      _vm._v("  "),
                      _c("strong", [_vm._v("设备类型：")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px", "margin-left": "10px" },
                        attrs: { placeholder: "请选择设备类型", size: "mini" },
                        on: { change: _vm.getCalculateTotalCost },
                        model: {
                          value: _vm.selectedDeviceType,
                          callback: function ($$v) {
                            _vm.selectedDeviceType = $$v
                          },
                          expression: "selectedDeviceType",
                        },
                      },
                      _vm._l(_vm.deviceTypeOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", [_c("div", [_c("strong", [_vm._v("   设备数量")])])]),
                _vm._v(" "),
                _c("div", { staticClass: "flex align-items-center mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "flex-wrap" },
                    [
                      _vm.selectedDeviceType != 0
                        ? [
                            _c("div", [
                              _vm.currentShopInfo.cdbcount > 0 &&
                              _vm.selectedDeviceType == 1
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "4G充电宝 " +
                                          _vm._s(_vm.currentShopInfo.cdbcount) +
                                          " 台"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "cdbCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdbCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdbCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdbCost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.cdbCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "cdbInstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdbInstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdbInstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdbInstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdbInstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "cdbLaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdbLaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdbLaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdbLaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdbLaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "cdbOtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdbOtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdbOtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdbOtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdbOtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.cdxcount > 0 &&
                              _vm.selectedDeviceType == 3
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "充电线 " +
                                          _vm._s(_vm.currentShopInfo.cdxcount) +
                                          " 条"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "cdxCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdxCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdxCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdxCost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.cdxCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "cdxInstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdxInstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdxInstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdxInstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdxInstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "cdxLaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdxLaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdxLaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdxLaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdxLaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "cdxOtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdxOtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdxOtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdxOtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdxOtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.cdz10count > 0 &&
                              _vm.selectedDeviceType == 5
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "10路桩 " +
                                          _vm._s(
                                            _vm.currentShopInfo.cdz10count
                                          ) +
                                          " 台"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "cdz10Cost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz10Cost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdz10Cost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz10Cost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.cdz10Cost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "cdz10InstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz10InstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz10InstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz10InstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz10InstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "cdz10LaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz10LaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz10LaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz10LaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz10LaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "cdz10OtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz10OtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz10OtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz10OtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz10OtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.cdz2count > 0 &&
                              _vm.selectedDeviceType == 5
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "2路4G " +
                                          _vm._s(
                                            _vm.currentShopInfo.cdz2count
                                          ) +
                                          " 个"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "cdz2Cost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2Cost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdz2Cost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2Cost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.cdz2Cost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "cdz2InstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2InstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2InstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2InstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2InstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "cdz2LaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2LaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdz2LaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2LaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2LaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "cdz2OtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2OtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdz2OtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2OtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2OtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.cdz2lycount > 0 &&
                              _vm.selectedDeviceType == 5
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "2路蓝牙 " +
                                          _vm._s(
                                            _vm.currentShopInfo.cdz2lycount
                                          ) +
                                          " 个"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "cdz2lyCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2lyCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdz2lyCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2lyCost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.cdz2lyCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "cdz2lybInstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2lybInstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2lybInstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2lybInstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2lybInstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "cdz2lybLaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2lybLaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2lybLaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2lybLaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2lybLaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "cdz2lybOtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2lybOtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2lybOtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2lybOtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2lybOtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.cdz2hpcount > 0 &&
                              _vm.selectedDeviceType == 5
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "2路大功率 " +
                                          _vm._s(
                                            _vm.currentShopInfo.cdz2hpcount
                                          ) +
                                          " 个"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "cdz2hpCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2hpCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.cdz2hpCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2hpCost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.cdz2hpCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "cdz2hpInstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2hpInstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2hpInstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2hpInstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2hpInstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "cdz2hpLaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2hpLaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2hpLaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2hpLaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2hpLaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "cdz2hpOtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "cdz2hpOtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.cdz2hpOtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "cdz2hpOtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.cdz2hpOtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.zmcdbcount > 0 &&
                              _vm.selectedDeviceType == 1
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "桌面充电宝 " +
                                          _vm._s(
                                            _vm.currentShopInfo.zmcdbcount
                                          ) +
                                          " 个"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "zmcdbCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "zmcdbCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.zmcdbCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "zmcdbCost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.zmcdbCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "zmcdbInstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "zmcdbInstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.zmcdbInstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "zmcdbInstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.zmcdbInstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "zmcdbLaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "zmcdbLaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.zmcdbLaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "zmcdbLaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.zmcdbLaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "zmcdbOtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "zmcdbOtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.zmcdbOtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "zmcdbOtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.zmcdbOtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentShopInfo.lykgczcount > 0 &&
                              _vm.selectedDeviceType == 5
                                ? _c("div", { staticClass: "device-row" }, [
                                    _c("div", { staticClass: "device-info" }, [
                                      _vm._v(
                                        "蓝牙开关插座 " +
                                          _vm._s(
                                            _vm.currentShopInfo.lykgczcount
                                          ) +
                                          " 个"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "device-costs" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "165px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calculateDeviceTotalCostByType(
                                                  "lykgczCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "lykgczCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.costForm.lykgczCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "lykgczCost",
                                                  $$v
                                                )
                                              },
                                              expression: "costForm.lykgczCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个设备成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceInstallationTotalCostByType(
                                                  "lykgczInstallCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "lykgczInstallCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.lykgczInstallCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "lykgczInstallCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.lykgczInstallCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个安装费用")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceLaborTotalCostByType(
                                                  "lykgczLaborCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "lykgczLaborCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.lykgczLaborCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "lykgczLaborCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.lykgczLaborCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个人工成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: { width: "185px" },
                                            attrs: {
                                              placeholder: "单价",
                                              size: "mini",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.calcDeviceOtherTotalCostByType(
                                                  "lykgczOtherCost"
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.validateNumber(
                                                  $event,
                                                  "lykgczOtherCost"
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.costForm.lykgczOtherCost,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.costForm,
                                                  "lykgczOtherCost",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "costForm.lykgczOtherCost",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [_vm._v("单个其他成本")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-alert el-alert--warning is-light",
                                staticStyle: {
                                  "margin-top": "10px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "el-alert__content" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "el-alert__description",
                                        staticStyle: {
                                          "font-size": "14px",
                                          color: "#E6A23C",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "温馨提示：重新成本单价进行计算前请手动清除下方设备成本。"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : [
                            _vm.currentShopInfo.cdbcount > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "4G充电宝 " +
                                        _vm._s(_vm.currentShopInfo.cdbcount) +
                                        " 台 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.cdxcount > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "充电线 " +
                                        _vm._s(_vm.currentShopInfo.cdxcount) +
                                        " 条 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.cdz10count > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "10路桩 " +
                                        _vm._s(_vm.currentShopInfo.cdz10count) +
                                        " 台 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.cdz2count > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "2路4G " +
                                        _vm._s(_vm.currentShopInfo.cdz2count) +
                                        " 个 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.cdz2lycount > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "2路蓝牙 " +
                                        _vm._s(
                                          _vm.currentShopInfo.cdz2lycount
                                        ) +
                                        " 个 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.cdz2hpcount > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "2路大功率 " +
                                        _vm._s(
                                          _vm.currentShopInfo.cdz2hpcount
                                        ) +
                                        " 个 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.zmcdbcount > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "桌面充电宝 " +
                                        _vm._s(_vm.currentShopInfo.zmcdbcount) +
                                        " 个 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentShopInfo.lykgczcount > 0
                              ? _c("div", { staticClass: "mr-3" }, [
                                  _c("div", [
                                    _vm._v(
                                      "蓝牙开关插座 " +
                                        _vm._s(
                                          _vm.currentShopInfo.lykgczcount
                                        ) +
                                        " 个 "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                      _vm._v(" "),
                      !_vm.currentShopInfo.cdbcount &&
                      !_vm.currentShopInfo.cdxcount &&
                      !_vm.currentShopInfo.cdz10count &&
                      !_vm.currentShopInfo.cdz2count &&
                      !_vm.currentShopInfo.cdz2lycount &&
                      !_vm.currentShopInfo.cdz2hpcount &&
                      !_vm.currentShopInfo.zmcdbcount &&
                      !_vm.currentShopInfo.lykgczcount
                        ? _c("span", { staticClass: "text-gray" }, [
                            _vm._v("暂无设备"),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.selectedDeviceType != 0
                  ? _c("div", [
                      _c("div", [_c("strong", [_vm._v("   各方投入占比")])]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex align-items-center mt-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-wrap" },
                            [
                              [
                                _c("div", { staticClass: "device-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "device-costs" },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            placeholder:
                                              "请输入0-100之间的数值",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInvestmentRatio(
                                                $event,
                                                "manage"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.investmentRatio.manage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investmentRatio,
                                                "manage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "investmentRatio.manage",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("总后台"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("%"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            placeholder:
                                              "请输入0-100之间的数值",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInvestmentRatio(
                                                $event,
                                                "partner"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.investmentRatio.partner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investmentRatio,
                                                "partner",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "investmentRatio.partner",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("城市合伙人"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("%"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            placeholder:
                                              "请输入0-100之间的数值",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInvestmentRatio(
                                                $event,
                                                "proxy"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.investmentRatio.proxy,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investmentRatio,
                                                "proxy",
                                                $$v
                                              )
                                            },
                                            expression: "investmentRatio.proxy",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("代理商"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("%"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            placeholder:
                                              "请输入0-100之间的数值",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInvestmentRatio(
                                                $event,
                                                "salesperson"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.investmentRatio.salesperson,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investmentRatio,
                                                "salesperson",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "investmentRatio.salesperson",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("业务员"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("%"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            placeholder:
                                              "请输入0-100之间的数值",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInvestmentRatio(
                                                $event,
                                                "promoter"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.investmentRatio.promoter,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investmentRatio,
                                                "promoter",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "investmentRatio.promoter",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("推广员"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("%"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            placeholder:
                                              "请输入0-100之间的数值",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInvestmentRatio(
                                                $event,
                                                "merchants"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.investmentRatio.merchants,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investmentRatio,
                                                "merchants",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "investmentRatio.merchants",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("商家"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("%"),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                            ],
                            2
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { height: "20px" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cost-section card-shadow card-elevation",
                staticStyle: {
                  "background-color": "#FAFAFC",
                  padding: "8px",
                  "border-radius": "12px",
                },
              },
              [
                _c("h3", [_vm._v("固定成本(元)")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cost-form" },
                  [
                    _c(
                      "el-form",
                      { attrs: { model: _vm.costForm, "label-width": "90px" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 29 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "设备成本" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.selectedDeviceType === "0",
                                        placeholder: "请输入设备成本",
                                      },
                                      model: {
                                        value: _vm.costForm.deviceCost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "deviceCost",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.deviceCost",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "安装费用" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.selectedDeviceType === "0",
                                        placeholder: "请输入安装费用",
                                      },
                                      model: {
                                        value: _vm.costForm.installationCost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "installationCost",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.installationCost",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "人工成本" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.selectedDeviceType === "0",
                                        placeholder: "请输入人工成本",
                                      },
                                      model: {
                                        value: _vm.costForm.laborCost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "laborCost",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.laborCost",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "其他成本" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.selectedDeviceType === "0",
                                        placeholder: "请输入其他成本",
                                      },
                                      model: {
                                        value: _vm.costForm.otherCost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "otherCost",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.otherCost",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 1 } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _vm.selectedDeviceType !== "0"
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: _vm.saveCalculateTotalCost,
                                            },
                                          },
                                          [_vm._v("保存")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.selectedDeviceType === "0",
                                placeholder: "请输入备注信息",
                              },
                              model: {
                                value: _vm.costForm.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.costForm, "remark", $$v)
                                },
                                expression: "costForm.remark",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "总成本" } },
                          [
                            _c("el-input", {
                              attrs: {
                                value: _vm.costForm.totalCost,
                                disabled: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { height: "20px" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "break-even-section card-shadow card-elevation" },
              [
                _c(
                  "div",
                  {
                    staticClass: "countdown",
                    staticStyle: {
                      "background-color": "#FAFAFC",
                      padding: "8px",
                      "border-radius": "12px",
                      "border-left": "6px solid #5047D8",
                    },
                  },
                  [
                    _c("h3", [_vm._v("回本倒计时")]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "days" }, [
                            _c("span", [_vm._v("预计剩余回本天数")]),
                            _vm._v(" "),
                            _c("h2", { staticStyle: { color: "#5047D8" } }, [
                              _vm._v(_vm._s(_vm.breakEvenDays)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c(
                            "div",
                            { staticClass: "progress" },
                            [
                              _c("el-progress", {
                                attrs: {
                                  percentage: _vm.breakEvenPercentage,
                                  "show-text": false,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.breakEvenPercentage) + "%"),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "20px" } }),
                _vm._v(" "),
                _c("div", [
                  _c("div", [_c("strong", [_vm._v("   回本分布情况")])]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex align-items-center mt-2" }, [
                    _c(
                      "div",
                      { staticClass: "flex-wrap" },
                      [
                        [
                          _c("div", { staticClass: "device-row" }, [
                            _c(
                              "div",
                              { staticClass: "device-costs" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "180px" },
                                    attrs: { size: "mini", disabled: "" },
                                    model: {
                                      value: _vm.recoveryRatio.manage,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.recoveryRatio,
                                          "manage",
                                          $$v
                                        )
                                      },
                                      expression: "recoveryRatio.manage",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v("总后台"),
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { size: "mini", disabled: "" },
                                    model: {
                                      value: _vm.recoveryRatio.partner,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.recoveryRatio,
                                          "partner",
                                          $$v
                                        )
                                      },
                                      expression: "recoveryRatio.partner",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v("城市合伙人"),
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "180px" },
                                    attrs: { size: "mini", disabled: "" },
                                    model: {
                                      value: _vm.recoveryRatio.proxy,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.recoveryRatio,
                                          "proxy",
                                          $$v
                                        )
                                      },
                                      expression: "recoveryRatio.proxy",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v("代理商"),
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "180px" },
                                    attrs: { size: "mini", disabled: "" },
                                    model: {
                                      value: _vm.recoveryRatio.salesperson,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.recoveryRatio,
                                          "salesperson",
                                          $$v
                                        )
                                      },
                                      expression: "recoveryRatio.salesperson",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v("业务员"),
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "180px" },
                                    attrs: { size: "mini", disabled: "" },
                                    model: {
                                      value: _vm.recoveryRatio.promoter,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.recoveryRatio,
                                          "promoter",
                                          $$v
                                        )
                                      },
                                      expression: "recoveryRatio.promoter",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v("推广员"),
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "220px" },
                                    attrs: { size: "mini", disabled: "" },
                                    model: {
                                      value: _vm.recoveryRatio.merchants,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.recoveryRatio,
                                          "merchants",
                                          $$v
                                        )
                                      },
                                      expression: "recoveryRatio.merchants",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v("商家"),
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "20px" } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stats" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "stat-item",
                              staticStyle: {
                                "background-color": "#FAFAFC",
                                padding: "8px",
                                "border-radius": "12px",
                              },
                            },
                            [
                              _c("span", [_vm._v("平均日收入")]),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.averageDailyIncome)),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "stat-item",
                              staticStyle: {
                                "background-color": "#FAFAFC",
                                padding: "8px",
                                "border-radius": "12px",
                              },
                            },
                            [
                              _c("span", [_vm._v("平均月收入")]),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.averageChangeMoneyMonth)),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "stat-item",
                              staticStyle: {
                                "background-color": "#FAFAFC",
                                padding: "8px",
                                "border-radius": "12px",
                              },
                            },
                            [
                              _c("span", [_vm._v("已营运天数")]),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.daysSinceOperation)),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "stat-item",
                              staticStyle: {
                                "background-color": "#FAFAFC",
                                padding: "8px",
                                "border-radius": "12px",
                              },
                            },
                            [
                              _c("span", [_vm._v("已收回成本")]),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(_vm.recoveredCost))]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "stat-item",
                              staticStyle: {
                                "background-color": "#FAFAFC",
                                padding: "8px",
                                "border-radius": "12px",
                              },
                            },
                            [
                              _c("span", [_vm._v("剩余成本")]),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(_vm.remainingCost))]),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("merchant-electricity-config-dialog", { ref: "electricityConfig" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "充值金额配置",
            visible: _vm.rechargeConfigDialog,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rechargeConfigDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否开启" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.rechargeConfigObj.is_use_self_banner,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.rechargeConfigObj,
                          "is_use_self_banner",
                          $$v
                        )
                      },
                      expression: "rechargeConfigObj.is_use_self_banner",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "充值金额配置" } }, [
                _c("div", { staticClass: "mb-10" }, [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { attrs: { width: "80" } }, [_vm._v("序号")]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "200" } }, [
                          _vm._v("充值金额（元）"),
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "200" } }, [
                          _vm._v("赠送金额（元）"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.rechargeConfigObj.config_list,
                        function (item, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    type: "number",
                                    placeholder: "必填",
                                  },
                                  model: {
                                    value: item.price,
                                    callback: function ($$v) {
                                      _vm.$set(item, "price", $$v)
                                    },
                                    expression: "item.price",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    type: "number",
                                    placeholder: "选填",
                                  },
                                  model: {
                                    value: item.send,
                                    callback: function ($$v) {
                                      _vm.$set(item, "send", $$v)
                                    },
                                    expression: "item.send",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rechargeConfigDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveRechargeConfig()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }